module.exports = __webpack_public_path__ + "img/4bdaa46b72203739118f37a8f9e33761.png";